/**
 * FIELD VISIT STEP LABELS & CONFIGURATION
 * 
 * New 9-step structure per Document 1 spec
 */

export const STEP_LABELS = [
  { step: 1, name: 'Client Intel', shortName: 'Intel', icon: '🎯' },
  { step: 2, name: 'Client Discovery', shortName: 'Discovery', icon: '🔍' },
  { step: 3, name: 'Decision Drivers', shortName: 'Drivers', icon: '⚡' },
  { step: 4, name: 'Measurements', shortName: 'Measure', icon: '📐' },
  { step: 5, name: 'Photos', shortName: 'Photos', icon: '📸' },
  { step: 6, name: 'Product Selection', shortName: 'Products', icon: '🛒' },
  { step: 7, name: 'Risk Ledger', shortName: 'Risks', icon: '⚠️' },
  { step: 8, name: 'Scope Description', shortName: 'Scope', icon: '📝' },
  { step: 9, name: 'Review & Complete', shortName: 'Complete', icon: '✅' },
];

export const TOTAL_STEPS = 9;

// Get step label by number
export const getStepLabel = (stepNumber) => {
  return STEP_LABELS.find(s => s.step === stepNumber) || STEP_LABELS[0];
};

// Get step progress percentage
export const getStepProgress = (currentStep) => {
  return Math.round((currentStep / TOTAL_STEPS) * 100);
};

export default { STEP_LABELS, TOTAL_STEPS, getStepLabel, getStepProgress };
